import React, { FC, lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import App from '../app/App';
import { MobileMenuStateProvider, useConfig } from 'contexts';
import HomePage from 'containers/pages/home-page/HomePage';
import { Loader } from 'kl-b2c-ui-kit';
import { DefaultTheme, withTheme } from 'styled-components';
import { ActionPageKey } from 'enums/action-page-key';

const CodeOfConduct = lazy(() => import('../pages/code-of-conduct/CodeOfConduct'));
const Location = lazy(() => import('../pages/location/Location'));
const ActionPage = lazy(() => import('../pages/action-page/ActionPage'));
const NotFoundPage = lazy(() => import('../../components/not-found-page/NotFoundPage'));
const Media = lazy(() => import('../pages/media/Media'));
const ArchivedPage = lazy(() => import('../pages/archived-page'));

interface Props {
    theme: DefaultTheme;
}

const AppRouter: FC<Props> = ({ theme }) => {
    const { appConfig } = useConfig();

    if (!appConfig) return null;

    return (
        <BrowserRouter>
            <MobileMenuStateProvider>
                <Suspense
                    fallback={<Loader variant="fixed" size="large" transparent customColor={theme.palette.teal} />}
                >
                    <Routes>
                        <Route path="/" element={<App />}>
                            <Route path="/" element={<HomePage theme={theme} />} />
                            <Route path="confirmation/:agreementId" element={<HomePage theme={theme} />} />
                            {/* <Route path="about" element={<AboutPage />} /> */}
                            <Route path="code" element={<CodeOfConduct />} />
                            {/* @ts-ignore */}
                            <Route path="location" element={<Location />} />
                            {/* @ts-ignore */}
                            <Route path="media" element={<Media />} />
                            <Route
                                path="registration"
                                // @ts-ignore
                                element={<ActionPage pageKey={ActionPageKey.Registration} />}
                            />
                            {/* @ts-ignore */}
                            <Route path="papers" element={<ActionPage pageKey={ActionPageKey.Papers} />} />
                            {/* @ts-ignore */}
                            <Route path="sponsors" element={<ActionPage pageKey={ActionPageKey.Sponsor} />} />
                            <Route path="archive/:id" element={<ArchivedPage />} />
                            <Route path="*" element={<NotFoundPage />} />
                        </Route>
                    </Routes>
                </Suspense>
            </MobileMenuStateProvider>
        </BrowserRouter>
    );
};

export default withTheme(AppRouter);
